"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkInfo = exports.rpcMap = void 0;
const types_1 = require("../../../types");
exports.rpcMap = {
    [types_1.EvmChain.FANTOM]: "https://rpc.testnet.fantom.network",
    [types_1.EvmChain.POLYGON]: "https://nd-244-242-844.p2pify.com/a336ed852bfcb6dd53869c8626be64fd",
    [types_1.EvmChain.MOONBEAM]: "https://rpc.api.moonbase.moonbeam.network",
    [types_1.EvmChain.AVALANCHE]: "https://api.avax-test.network/ext/bc/C/rpc",
    "ethereum-2": "https://goerli.infura.io/v3/510b6d5b3c56497b8070626a54f565a9",
    [types_1.EvmChain.AURORA]: "https://testnet.aurora.dev",
    [types_1.EvmChain.BINANCE]: "https://data-seed-prebsc-1-s1.binance.org:8545",
    [types_1.EvmChain.BNBCHAIN]: "https://data-seed-prebsc-1-s1.binance.org:8545",
    [types_1.EvmChain.ARBITRUM]: "https://goerli-rollup.arbitrum.io/rpc",
    [types_1.EvmChain.CELO]: "https://alfajores-forno.celo-testnet.org",
    [types_1.EvmChain.KAVA]: "https://evm.testnet.kava.io",
    [types_1.EvmChain.BASE]: "https://goerli.base.org",
    [types_1.EvmChain.FILECOIN]: "https://filecoin-calibration.chainup.net/rpc/v1",
    [types_1.EvmChain.OPTIMISM]: "https://goerli.optimism.io",
    [types_1.EvmChain.LINEA]: "https://rpc.goerli.linea.build",
    [types_1.EvmChain.POLYGON_ZKEVM]: "https://testnet-zkevm.polygonscan.com",
    [types_1.EvmChain.MANTLE]: "https://rpc.testnet.mantle.xyz",
};
exports.networkInfo = {
    [types_1.EvmChain.FANTOM]: {
        chainId: 4002,
        name: types_1.EvmChain.FANTOM,
    },
    [types_1.EvmChain.POLYGON]: {
        chainId: 80001,
        name: types_1.EvmChain.POLYGON,
    },
    [types_1.EvmChain.POLYGON_ZKEVM]: {
        chainId: 1442,
        name: types_1.EvmChain.POLYGON_ZKEVM,
    },
    [types_1.EvmChain.MOONBEAM]: {
        chainId: 1287,
        name: types_1.EvmChain.MOONBEAM,
    },
    [types_1.EvmChain.AVALANCHE]: {
        chainId: 43113,
        name: types_1.EvmChain.AVALANCHE,
    },
    "ethereum-2": {
        chainId: 5,
        name: types_1.EvmChain.ETHEREUM,
    },
    [types_1.EvmChain.AURORA]: {
        chainId: 1313161555,
        name: types_1.EvmChain.AURORA,
    },
    [types_1.EvmChain.BINANCE]: {
        chainId: 97,
        name: types_1.EvmChain.BINANCE,
    },
    [types_1.EvmChain.BNBCHAIN]: {
        chainId: 97,
        name: types_1.EvmChain.BNBCHAIN,
    },
    [types_1.EvmChain.ARBITRUM]: {
        chainId: 421613,
        name: `${types_1.EvmChain.ARBITRUM}-goerli`,
    },
    [types_1.EvmChain.CELO]: {
        chainId: 44787,
        name: types_1.EvmChain.CELO,
    },
    [types_1.EvmChain.KAVA]: {
        chainId: 2221,
        name: types_1.EvmChain.KAVA,
    },
    [types_1.EvmChain.BASE]: {
        chainId: 84531,
        name: types_1.EvmChain.BASE,
    },
    [types_1.EvmChain.FILECOIN]: {
        chainId: 314159,
        name: types_1.EvmChain.FILECOIN,
    },
    [types_1.EvmChain.OPTIMISM]: {
        chainId: 420,
        name: `${types_1.EvmChain.OPTIMISM}-goerli`,
    },
    [types_1.EvmChain.LINEA]: {
        chainId: 59140,
        name: types_1.EvmChain.LINEA,
    },
    [types_1.EvmChain.MANTLE]: {
        chainId: 5001,
        name: types_1.EvmChain.MANTLE,
    },
};
//# sourceMappingURL=testnet.js.map